import { z } from 'zod'

export const SHOPIFY_ATTRIBUTION_KEYS = {
  subscriberPseudonymousId: 'subscriber_pseudonymous_id',
  campaignPseudonymousId: 'campaign_pseudonymous_id',
} as const

export const ShopifyCheckoutAttributeSchema = z.object({
  key: z.enum([SHOPIFY_ATTRIBUTION_KEYS.subscriberPseudonymousId, SHOPIFY_ATTRIBUTION_KEYS.campaignPseudonymousId]),
  value: z.string().trim().min(1).max(256),
})

export const ShopifyNoteAttributeSchema = z.object({
  name: z.string(),
  value: z.string().nullable().optional(),
})

export const ShopifyOrdersPaidWebhookSchema = z.object({
  id: z.union([z.string(), z.number()]),
  currency: z.string().trim().length(3),
  total_price: z.union([z.string(), z.number()]),
  note_attributes: z.array(ShopifyNoteAttributeSchema).optional().default([]),
})

export const ShopifyWebhookResultSchema = z.object({
  accepted: z.boolean(),
  duplicate: z.boolean(),
  unattributed: z.boolean(),
})

export type ShopifyNoteAttribute = z.infer<typeof ShopifyNoteAttributeSchema>
export type ShopifyCheckoutAttribute = z.infer<typeof ShopifyCheckoutAttributeSchema>
export type ShopifyOrdersPaidWebhook = z.infer<typeof ShopifyOrdersPaidWebhookSchema>
export type ShopifyWebhookResult = z.infer<typeof ShopifyWebhookResultSchema>
